import script from "/app/components/confirm_button.vue?type=script";
import "/app/components/confirm_button.vue?type=style";
import { render } from "/app/components/confirm_button.vue?type=template";
script.render = render;
export default script;
